import React from "react";

export const PriceColumnFormatter = (cellContent, row) => <>&pound;{parseFloat(cellContent).toFixed(2)}</>;

